<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';
import axios from 'axios';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiToken: '',
      channelId: '',
      channels: [],
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required },
    apiToken: { required },
    channelId: { required },
  },
  methods: {
    async fetchChannels() {
      if (!this.apiToken) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.$route.params.accountId}/notificame/channels`,
          { params: { token: this.apiToken } }
        );
        this.channels = data.channels || [];
      } catch (error) {
        useAlert(error.message);
      }
    },
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'whatsapp',
            phone_number: this.phoneNumber,
            provider: 'notificame',
            provider_config: {
              api_token: this.apiToken,
              channel_id: this.channelId,
            },
          },
        });
        this.$router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: inbox.id },
        });
      } catch (error) {
        useAlert(error.message);
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')"
          @blur="v$.phoneNumber.$touch"
        />
        <span v-if="v$.phoneNumber.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiToken.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.NOTIFICAME_TOKEN.LABEL') }}
        <input
          v-model="apiToken"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.NOTIFICAME_TOKEN.PLACEHOLDER')
          "
          @blur="fetchChannels"
        />
        <span v-if="v$.apiToken.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.NOTIFICAME_TOKEN.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.channelId.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.LABEL') }}
        <select v-model="channelId" @blur="v$.channelId.$touch">
          <option value="" disabled>
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.PLACEHOLDER') }}
          </option>
          <option v-for="ch in channels" :key="ch.id" :value="ch.id">
            {{ ch.name }}
          </option>
        </select>
        <span v-if="v$.channelId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
